module.exports = __webpack_public_path__ + "img/image_6.3f232aba.jpg";